module.exports = __webpack_public_path__ + "static/img/banner-05.895bec5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/mobile/banner-05.png
// module id = gl1c
// module chunks = 1